export enum Deployment {
    CLOUD = 'cloud',
    DATA_CENTER = 'data_center'
}

export enum SortBy {
    RELEVANCE = 'relevance',
    LAST_PUBLISHED = 'last_published'
}

// ----- V2 Types -----

export interface SearchOptionsGenericValue {
    key: string;
    name: string;
}

export interface SearchOptionsProductValue extends SearchOptionsGenericValue {
    versions?: string[];
}

export interface SearchOptionsPlatformValue extends SearchOptionsGenericValue {
    products: SearchOptionsProductValue[];
}

export interface SearchOptionsApiResponse {
    filters: {
        platforms: SearchOptionsPlatformValue[];
        contentTypes: SearchOptionsGenericValue[];
    };
    sortOptions: SearchOptionsGenericValue[];
}

// ----- V1 Types -----

export interface FiltersApiResponse {
    products: FilterValue[];
    documentTypes: string[];
}

export interface FilterValue {
    key: string;
    name: string;
    platform?: Deployment;
    versions?: string[];
}

export enum Content {
    KNOWLEDGE_BASE = 'knowledge_base',
    DOCUMENTATION = 'documentation'
}

export const contentArray: FilterValue[] = [
    {
        name: 'Knowledge Base',
        key: Content.KNOWLEDGE_BASE
    },
    {
        name: 'Documentation',
        key: Content.DOCUMENTATION
    }
];

export const deploymentsArray: FilterValue[] = [
    {
        name: 'Cloud',
        key: Deployment.CLOUD
    },
    {
        name: 'Data Center',
        key: Deployment.DATA_CENTER
    }
];
